import React from 'react'

function SVGWave () {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1440 320'><path fill='#fff' fillOpacity='1' d='M0,224L120,240C240,256,480,288,720,256C960,224,1200,128,1320,80L1440,32L1440,320L1320,320C1200,320,960,320,720,320C480,320,240,320,120,320L0,320Z' /></svg>
  )
}

export default SVGWave
